import React, { PropTypes } from 'react';
import { reduxForm } from 'redux-form';
import validateTool from 'validate.js';
import Input from '../../../../form/Input';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

const validate = (data) => {
  return validateTool(data, {
      first_score: {
        presence: true,
        numericality: {
          onlyInteger: true,
          greaterThanOrEqualTo: 0
        }
      },
      second_score: {
        presence: true,
        numericality: {
          onlyInteger: true,
          greaterThanOrEqualTo: 0
        }
      }
    }) || {};
};

class AnnounceMatchResultDialog extends React.Component {
  static propTypes = {
    onSubmit: PropTypes.func,
    onClose: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired
  };

  handleSubmit() {
    let { handleSubmit, onSubmit}= this.props;
    return handleSubmit(onSubmit)
      .catch(errors => (
        /*eslint  no-console: 0*/
        console.info('save fail', errors)
      ))
  }

  render() {
    let {
          fields: {first_score, second_score},
          open,
          onClose
        } = this.props;

    const actions = [
      <FlatButton
        label="Cancel"
        secondary={true}
        onClick={onClose}
      />,
      <FlatButton
        label="Submit"
        primary={true}
        type="submit"
        onClick={() => this.handleSubmit()}
      />
    ];

    const style = {
      inputContainer: {
        display: 'flex'
      },
      inputItem: {
        width: '50%',
        display: 'block'
      }
    };

    return (
      <form onSubmit={() => this.handleSubmit()}>
        <Dialog
          title="Dialog With Actions"
          actions={actions}
          modal={false}
          open={open}
          onRequestClose={this.handleClose}
        >
          <div style={style.inputContainer}>
            <Input label="First score" required style={style.inputItem} {...first_score}/>
            <Input label="Second score" required style={style.inputItem} {...second_score}/>
          </div>
        </Dialog>
      </form>
    );
  }
}

export default reduxForm(
  {
    form: 'AnnounceMatchResultDialog',
    fields: [
      'first_score', 'second_score'
    ],
    returnRejectedSubmitPromise: true,
    validate
  }
)(AnnounceMatchResultDialog);




// WEBPACK FOOTER //
// ./src/components/Events/EventsEditForm/votings/MatchResultVoting/AnnounceMatchResultDialog.jsx